var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_vm._v(" Redirecionando... ")])])
}]

export { render, staticRenderFns }